import React, { useContext, useState } from "react";
import {
  Container,
  Nav,
  Popover,
  OverlayTrigger,
  Button,
  Navbar,
  Card,
} from "react-bootstrap";
import { NavLink, Link } from "react-router-dom";
import logo from "../../images/logo.png";
import { UserContext } from "../UserContext";

const Dashboard = (props) => {
  const users = useContext(UserContext);
  function logOut() {
    users.setUser(null);
    localStorage.removeItem("access_token");
  }
  const popover = (
    <Popover id="popover-basic">
      <Popover.Content className="px-0 py-3">
        <Link
          onClick={logOut}
          className="log-out px-4 py-2 text-decoration-none text-dark"
          to="#"
        >
          Log Out
        </Link>
      </Popover.Content>
    </Popover>
  );
  const [side, setSide] = useState(false);
  return (
    <>
      <Container fluid className="p-0">
        <div className="d-flex">
          <div
            className="sidebar-wrapper p-0"
            style={{
              transform: side ? "translateX(0px)" : "",
            }}
          >
            <Link
              className="navbar-brand mb-2 bg-white w-100 d-flex justify-content-center"
              to="/"
            >
              <img src={logo} alt="logo" height="42px" />
            </Link>
            <Nav defaultActiveKey="/home" className="flex-column">
              <NavLink
                to="/admin/dashboard"
                activeClassName="is-active"
                className="nav-link py-3 "
              >
                <i className="fa fa-home mr-2" />
                Dashboard
              </NavLink>
              <NavLink
                to="/admin/listings"
                activeClassName="is-active"
                className="nav-link py-3 "
              >
                <i className="fa fa-list mr-2" />
                All Listings
              </NavLink>
              <NavLink
                to="/admin/categories"
                className="nav-link py-3 "
                activeClassName="is-active"
              >
                <i className="fa fa-list-alt mr-2" aria-hidden="true" />
                Categories
              </NavLink>
              <NavLink
                to="/admin/advert"
                className="nav-link py-3 "
                activeClassName="is-active"
              >
                <i className="fa fa-puzzle-piece mr-2" aria-hidden="true" />
                Adverts
              </NavLink>
            </Nav>
          </div>

          <div
            className="dash-right"
            onClick={() => (side ? setSide(false) : null)}
          >
            <Navbar
              collapseOnSelect
              expand="lg"
              className="dark navbar-fix"
              variant="dark"
            >
              <Container>
                <Nav className="mr-auto">
                  <i
                    className="fa fa-bars pointer-event text-grey hamb"
                    onClick={() => setSide(!side)}
                  />
                </Nav>
                <Nav>
                  <OverlayTrigger
                    trigger="click"
                    placement="bottom"
                    overlay={popover}
                  >
                    <Button
                      variant="outline-dark dash-btn"
                      className="border-0 "
                    >
                      <i className="fal fa-user-circle text-grey pr-1"></i>
                      {props.user}
                    </Button>
                  </OverlayTrigger>
                </Nav>
              </Container>
            </Navbar>
            <Card.Header className="py-3 mt-head fs-24 font-weight-bold text-new-grey">
              {props.page}
            </Card.Header>
            {props.children}
          </div>
        </div>
      </Container>
    </>
  );
};
export default Dashboard;
